<script>

    import { onMount } from 'svelte';

    let {
        style = '',
        name,
        initials,
        src,
        bgColor = 'lightGrey',
        textColor = 'white',
        size = '50px',
        borderRadius = '50%',
        square = false,
        randomBgColor = false
    } = $props();

    const background = randomBgColor ? getRandomColor() : bgColor;
    let abbr = $derived(initials || getInitials(name));
    let abbrLength = $derived(abbr.length);
    let imageFail = $state(false);
    let imageLoading = $state(true);

    function getRandomColor () {
        const colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#FFEB3B', '#FFC107', '#FF5722', '#795548'];
        const i = Math.floor(Math.random() * colors.length);
        return colors[i];
    }

    onMount(() => {
        imageLoading = false;
    });

    function getInitials (name) {
        if(!name) {
            name = ';)';
        } else if(typeof name !== 'string') {
            name = name.toString();
        }

        let initials = name.split(/[,.()\s]+/);

        if (name.length <= 2) {
            initials = name;
        } else if (initials.length > 1) {
            initials = initials.shift().charAt(0) + initials.pop().charAt(0);
        } else {
            initials = (name.length > 2) ? name.substring(0, 1) : name;
        }

        return initials.toUpperCase();
    };
</script>
  
<div
    aria-label={name}
    class="wrapper"
    style="{style}--borderRadius:{square
      ? 0
      : borderRadius}; --size:{size}; --bgColor:{background};
    --src:{src}; --textColor:{textColor}; --abbrLength:{abbrLength}"
>
    {#if src && !imageFail}
      <div class={imageLoading ? 'imageLoading' : ''}>
        <img
          alt=""
          class={`innerImage`}
          {src}
          onerror={() => (imageFail = true)}
          onload={() => {imageLoading = false}}
        />
      </div>
    {:else}
      <div class="innerInitials">{abbr}</div>
    {/if}
</div>
  
<style>
    .wrapper {
        position: relative;
        width: var(--size);
        height: var(--size);
    }
  
    .innerImage,
    .innerInitials,
    .imageLoading {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: var(--borderRadius);
    }
  
    .innerInitials {
        font-family: CaracteresL1, sans-serif;
        line-height: var(--size);
        background-color: var(--bgColor);
        color: var(--textColor);
        text-align: center;
        font-size: calc(var(--size) / (var(--abbrLength) + 0.5));
    }

    @media (prefers-color-scheme: light) {
        .imageLoading {
            background-color: var(--bgColor);
        }

        .imageLoading::before {
            content: '';
            display: block;
            height: 100%;
            width: 100%;
            background: linear-gradient(90deg, transparent, #ffffff38, transparent);
            position: absolute;
            top: 0;
            left: 0;
            animation: skeleton-animation 1.2s linear infinite;
        }
    }

  
    @keyframes skeleton-animation {
        0% {
            transform: translateX(-100%);
        }
        100% {
            transform: translateX(100%);
        }
    }
</style>

